const additionalOptions = document.querySelectorAll(
	'.custom-checkbox input[type="checkbox"]'
);

additionalOptions.forEach((option) => {
	option.addEventListener('change', handleUpsellOptionClick);
});

function handleUpsellOptionClick(e) {
	e.preventDefault();
	const idValue = e.target.value;
	if (e.target.checked) {
		customAddToCart(idValue);
	} else {
		customRemoveFromCart(idValue);
	}
}

async function customAddToCart(idValue) {
	try {
		const response = await fetch('/cart/add.js', {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
			},
			body: JSON.stringify({
				items: [
					{
						id: `${idValue}`,
						quantity: 1,
					},
				],
			}),
		});
		const data = await response.json();
		const itemCount = data.item_count;

		customUpdateCart('/?section_id=cart-drawer', 'add');
	} catch (error) {
		console.error(error);
	}
}

async function customRemoveFromCart(idValue) {
	try {
		const response = await fetch('/cart/update.js', {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
			},
			body: JSON.stringify({
				updates: {
					[idValue]: 0,
				},
			}),
		});
		const data = await response.json();
		const itemCount = data.item_count;

		customUpdateCart('/?section_id=cart-drawer', 'remove', itemCount);
	} catch (error) {
		console.error(error);
	}
}

async function customUpdateCart(sectionUrl, endpoint, itemCount) {
	try {
		const response = await fetch(sectionUrl);
		const responseText = await response.text();

		const html = new DOMParser()
			.parseFromString(responseText, 'text/html')
			.getElementById('CartDrawer').innerHTML;
		const cartDrawer = document.getElementById('CartDrawer');
		cartDrawer.innerHTML = html;

		const cartCountBubble = document.querySelector(
			'.cart-count-bubble span[aria-hidden]'
		);

		if (endpoint === 'add') {
			// remove is-empty class from cart drawer
			const cartDrawerHtml = document.querySelector('cart-drawer');
			cartDrawerHtml.classList.remove('is-empty');
		} else {
			// remove
			// if item count is 0
			// if item count > 0, update item count
			if (itemCount === 0) {
			} else {
				cartCountBubble.textContent = itemCount;
			}
			console.log('remove');
		}
	} catch (error) {
		console.error(error);
	}
}

// change buy it now button to checkout
